import {
    helpers
} from 'vuelidate/lib/validators'
export const rulePhone = helpers.regex('phone', /^1[3-9]\d{9}$/);

export const ruleContacts = helpers.regex('contacts', /^[\u4e00-\u9fa5]{2,5}$/);

export const ruleEmail = helpers.regex('email', /^([a-zA-Z0-9]+[-_.]?)+@[a-zA-Z0-9]+\.[a-z]+$/);

export const ruleOther = helpers.regex('other', /^([-_a-zA-Z0-9]{5,19})+$/);